import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrderStatusState } from './order-status.state';

export const selectOrderStatusState = createFeatureSelector<OrderStatusState>('order-status');

export const selectOrderStatusStep = createSelector(selectOrderStatusState, (state) => state.step);

export const selectOrderStatus = createSelector(selectOrderStatusState, (state) => state.orderStatus);

export const selectOrderNumber = createSelector(selectOrderStatusState, (state) => state.orderNumber);
